import React, { FC, useState, useEffect, ReactNode } from 'react'
import { IonModal, IonContent, IonFooter } from '@ionic/react'
import { format } from '@dt/fe-utils'
import { money } from './util'

interface IProps {
  visible: boolean;
  amount?: number;
  header?: ReactNode;
  max?: number;
  onSave?(amount: number): void;
  onClose?(): void;
}

const AmountKeyboard: FC<IProps> = ({ visible, amount, header, max, onSave, onClose }) => {
  const defaultText = typeof amount === 'number' ? money(amount) : ''
  const [text, setText] = useState(defaultText)
  const [noInput, setNoInput] = useState(true)

  useEffect(() => {
    const defaultText = typeof amount === 'number' ? money(amount) : ''
    setText(defaultText)
    setNoInput(true)
  }, [visible])

  const realText = noInput ? '' : text

  const periodIndex = realText.indexOf('.')
  const hasPeriod = periodIndex > -1
  const fractionLength = hasPeriod ? realText.length - (periodIndex + 1) : 0

  const inputDigit = (digit: number) => {
    if (!hasPeriod || fractionLength < 2) {
      setNoInput(false)
      setText(realText + String(digit))
    }
  }

  const inputPeriod = () => {
    if (!hasPeriod) {
      setNoInput(false)
      if (realText.length === 0) {
        setText('0.')
      } else {
        setText(realText + '.')
      }
    }
  }

  const backspace = () => {
    if (realText.length > 0) {
      setNoInput(false)
      setText(realText.substr(0, realText.length - 1))
    }
  }

  const cancel = () => {
    onClose && onClose()
  }

  const submit = () => {
    let amount = parseFloat(text)
    if (amount > max) {
      amount = max
    }
    onSave && onSave(amount)
  }

  useEffect(() => {
    try {
      const amount = parseFloat(text)
      if (max && amount > max) {
        setText(max.toFixed(2))
      }
    } catch (e) {
    }
  }, [text])

  let canSubmit = !!text
  try {
    parseFloat(text)
  } catch (e) {
    canSubmit = false
  }

  return (
    <IonModal isOpen={visible} cssClass='amount-keyboard-modal'>
      <IonContent>
        <div className='header'>
          {header}
          {max != null && (
            <div className='max'>
              <span>Max</span>
              <span>{money(max)}</span>
            </div>
          )}
        </div>
        <div className={`amount${noInput ? ' no-input' : ''}`}>
          {noInput ? text : format.toPrice(text)}
        </div>
        <ul className='numpad'>
          {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(x => (
            <li key={x} onClick={() => inputDigit(x)}>{x}</li>
          ))}
          <li onClick={() => inputPeriod()}>.</li>
          <li onClick={() => inputDigit(0)}>0</li>
          <li onClick={() => backspace()}>
            <i className='iconfont icon-backspace' />
          </li>
        </ul>
      </IonContent>
      <IonFooter className='button-bar'>
        <button className='cancel-button' onClick={cancel}>Cancel</button>
        <button className='submit-button' disabled={!canSubmit} onClick={submit}>OK</button>
      </IonFooter>
    </IonModal>
  )
}

export default AmountKeyboard
